/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
    type V1ApplicationKind,
    V1ApplicationKindFromJSON,
    V1ApplicationKindToJSON
} from '../models/V1ApplicationKind'
import {
    type V1CoachApplication,
    V1CoachApplicationFromJSON,
    V1CoachApplicationToJSON
} from '../models/V1CoachApplication'
import {
    type V1CoachApplicationDecision,
    V1CoachApplicationDecisionFromJSON,
    V1CoachApplicationDecisionToJSON
} from '../models/V1CoachApplicationDecision'
import {
    type V1CoachApplicationList,
    V1CoachApplicationListFromJSON,
    V1CoachApplicationListToJSON
} from '../models/V1CoachApplicationList'
import {
    type V1CoachApplicationPayload,
    V1CoachApplicationPayloadFromJSON,
    V1CoachApplicationPayloadToJSON
} from '../models/V1CoachApplicationPayload'
import {
    type V1CoachSettings,
    V1CoachSettingsFromJSON,
    V1CoachSettingsToJSON
} from '../models/V1CoachSettings'
import {
    type V1CoachSettingsPayload,
    V1CoachSettingsPayloadFromJSON,
    V1CoachSettingsPayloadToJSON
} from '../models/V1CoachSettingsPayload'
import {
    type V1CreateRequestPayload,
    V1CreateRequestPayloadFromJSON,
    V1CreateRequestPayloadToJSON
} from '../models/V1CreateRequestPayload'
import {
    type V1ErrorResponse,
    V1ErrorResponseFromJSON,
    V1ErrorResponseToJSON
} from '../models/V1ErrorResponse'
import {
    type V1MessageList,
    V1MessageListFromJSON,
    V1MessageListToJSON
} from '../models/V1MessageList'
import {
    type V1PayoutWallet,
    V1PayoutWalletFromJSON,
    V1PayoutWalletToJSON
} from '../models/V1PayoutWallet'
import {
    type V1ProgrammeRequest,
    V1ProgrammeRequestFromJSON,
    V1ProgrammeRequestToJSON
} from '../models/V1ProgrammeRequest'
import {
    type V1ProgrammeRequestList,
    V1ProgrammeRequestListFromJSON,
    V1ProgrammeRequestListToJSON
} from '../models/V1ProgrammeRequestList'
import {
    type V1RequestEvent,
    V1RequestEventFromJSON,
    V1RequestEventToJSON
} from '../models/V1RequestEvent'
import {
    type V1RevealedProgramme,
    V1RevealedProgrammeFromJSON,
    V1RevealedProgrammeToJSON
} from '../models/V1RevealedProgramme'
import {
    type V1SendMessagePayload,
    V1SendMessagePayloadFromJSON,
    V1SendMessagePayloadToJSON
} from '../models/V1SendMessagePayload'
import {
    type V1StatusUpdatePayload,
    V1StatusUpdatePayloadFromJSON,
    V1StatusUpdatePayloadToJSON
} from '../models/V1StatusUpdatePayload'

export interface CreateRequestRequest {
    /**
     *
     */
    v1CreateRequestPayload: V1CreateRequestPayload
}

export interface DecideCoachApplicationRequest {
    /**
     *
     */
    id: string
    /**
     *
     */
    v1CoachApplicationDecision: V1CoachApplicationDecision
}

export interface GetCoachApplicationRequest {
    /**
     * Which application to read. Defaults to coach.
     */
    kind?: V1ApplicationKind
}

export interface GetRequestRequest {
    /**
     *
     */
    id: string
}

export interface GetRequestProgrammeRequest {
    /**
     *
     */
    id: string
}

export interface ListCoachApplicationsRequest {
    /**
     *
     */
    kind?: V1ApplicationKind
    /**
     *
     */
    status?: ListCoachApplicationsStatusEnum
    /**
     *
     */
    page?: number
    /**
     *
     */
    perPage?: number
}

export interface ListRequestMessagesRequest {
    /**
     *
     */
    id: string
    /**
     *
     */
    limit?: number
    /**
     *
     */
    offset?: number
    /**
     * Sort direction by created_at
     */
    order?: ListRequestMessagesOrderEnum
}

export interface ListRequestsRequest {
    /**
     *
     */
    requesterId?: string
    /**
     *
     */
    coachId?: string
    /**
     *
     */
    status?: Array<string>
    /**
     *
     */
    limit?: number
    /**
     *
     */
    offset?: number
}

export interface ListenRequestEventsRequest {
    /**
     *
     */
    id: string
}

export interface SaveCoachSettingsRequest {
    /**
     *
     */
    v1CoachSettingsPayload: V1CoachSettingsPayload
}

export interface SavePayoutWalletRequest {
    /**
     *
     */
    v1PayoutWallet: V1PayoutWallet
}

export interface SendRequestMessageRequest {
    /**
     *
     */
    id: string
    /**
     *
     */
    v1SendMessagePayload: V1SendMessagePayload
}

export interface SubmitCoachApplicationRequest {
    /**
     *
     */
    v1CoachApplicationPayload: V1CoachApplicationPayload
}

export interface UpdateRequestStatusRequest {
    /**
     *
     */
    id: string
    /**
     *
     */
    v1StatusUpdatePayload: V1StatusUpdatePayload
}

/**
 *
 */
export class CommunityApi extends runtime.BaseAPI {
    /**
     * Creates request options for createRequest without sending the request
     */
    async createRequestRequestOpts(
        requestParameters: CreateRequestRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1CreateRequestPayload'] == null) {
            throw new runtime.RequiredError(
                'v1CreateRequestPayload',
                'Required parameter "v1CreateRequestPayload" was null or undefined when calling createRequest().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests`

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1CreateRequestPayloadToJSON(
                requestParameters['v1CreateRequestPayload']
            )
        }
    }

    /**
     * Create a new programme request with Stars escrow payment
     */
    async createRequestRaw(
        requestParameters: CreateRequestRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1ProgrammeRequest>> {
        const requestOptions =
            await this.createRequestRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1ProgrammeRequestFromJSON(jsonValue)
        )
    }

    /**
     * Create a new programme request with Stars escrow payment
     */
    async createRequest(
        requestParameters: CreateRequestRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1ProgrammeRequest> {
        const response = await this.createRequestRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for decideCoachApplication without sending the request
     */
    async decideCoachApplicationRequestOpts(
        requestParameters: DecideCoachApplicationRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling decideCoachApplication().'
            )
        }

        if (requestParameters['v1CoachApplicationDecision'] == null) {
            throw new runtime.RequiredError(
                'v1CoachApplicationDecision',
                'Required parameter "v1CoachApplicationDecision" was null or undefined when calling decideCoachApplication().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/coach/applications/{id}/decision`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1CoachApplicationDecisionToJSON(
                requestParameters['v1CoachApplicationDecision']
            )
        }
    }

    /**
     * Approving grants the ABAC attribute selected in the record\'s \"grant\" field (PocketBase dropdown). Coach applications fall back to coachSubscription; business applications must have a grant selected. The applicant picks it up on the next token exchange.
     * Approve or decline a coach or business application (admin only)
     */
    async decideCoachApplicationRaw(
        requestParameters: DecideCoachApplicationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1CoachApplication>> {
        const requestOptions =
            await this.decideCoachApplicationRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1CoachApplicationFromJSON(jsonValue)
        )
    }

    /**
     * Approving grants the ABAC attribute selected in the record\'s \"grant\" field (PocketBase dropdown). Coach applications fall back to coachSubscription; business applications must have a grant selected. The applicant picks it up on the next token exchange.
     * Approve or decline a coach or business application (admin only)
     */
    async decideCoachApplication(
        requestParameters: DecideCoachApplicationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1CoachApplication> {
        const response = await this.decideCoachApplicationRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for getCoachApplication without sending the request
     */
    async getCoachApplicationRequestOpts(
        requestParameters: GetCoachApplicationRequest
    ): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        if (requestParameters['kind'] != null) {
            queryParameters['kind'] = requestParameters['kind']
        }

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/coach/application`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Returns status \"none\" when the caller has never applied for that kind, so clients do not have to treat a 404 as a normal state.
     * Get the caller\'s latest coach or business application
     */
    async getCoachApplicationRaw(
        requestParameters: GetCoachApplicationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1CoachApplication>> {
        const requestOptions =
            await this.getCoachApplicationRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1CoachApplicationFromJSON(jsonValue)
        )
    }

    /**
     * Returns status \"none\" when the caller has never applied for that kind, so clients do not have to treat a 404 as a normal state.
     * Get the caller\'s latest coach or business application
     */
    async getCoachApplication(
        requestParameters: GetCoachApplicationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1CoachApplication> {
        const response = await this.getCoachApplicationRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for getCoachSettings without sending the request
     */
    async getCoachSettingsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/coach/settings`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Get coach request settings
     */
    async getCoachSettingsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1CoachSettings>> {
        const requestOptions = await this.getCoachSettingsRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1CoachSettingsFromJSON(jsonValue)
        )
    }

    /**
     * Get coach request settings
     */
    async getCoachSettings(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1CoachSettings> {
        const response = await this.getCoachSettingsRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for getPayoutWallet without sending the request
     */
    async getPayoutWalletRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/coach/payout-wallet`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * The TON wallet the signed-in coach\'s payouts are sent to
     */
    async getPayoutWalletRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1PayoutWallet>> {
        const requestOptions = await this.getPayoutWalletRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1PayoutWalletFromJSON(jsonValue)
        )
    }

    /**
     * The TON wallet the signed-in coach\'s payouts are sent to
     */
    async getPayoutWallet(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1PayoutWallet> {
        const response = await this.getPayoutWalletRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for getRequest without sending the request
     */
    async getRequestRequestOpts(
        requestParameters: GetRequestRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRequest().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/{id}`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Get programme request details
     */
    async getRequestRaw(
        requestParameters: GetRequestRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1ProgrammeRequest>> {
        const requestOptions =
            await this.getRequestRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1ProgrammeRequestFromJSON(jsonValue)
        )
    }

    /**
     * Get programme request details
     */
    async getRequest(
        requestParameters: GetRequestRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1ProgrammeRequest> {
        const response = await this.getRequestRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for getRequestProgramme without sending the request
     */
    async getRequestProgrammeRequestOpts(
        requestParameters: GetRequestProgrammeRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRequestProgramme().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/{id}/programme`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Get delivered programme with day-by-day reveal (coach sees full, user sees filtered)
     */
    async getRequestProgrammeRaw(
        requestParameters: GetRequestProgrammeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1RevealedProgramme>> {
        const requestOptions =
            await this.getRequestProgrammeRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1RevealedProgrammeFromJSON(jsonValue)
        )
    }

    /**
     * Get delivered programme with day-by-day reveal (coach sees full, user sees filtered)
     */
    async getRequestProgramme(
        requestParameters: GetRequestProgrammeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1RevealedProgramme> {
        const response = await this.getRequestProgrammeRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for listCoachApplications without sending the request
     */
    async listCoachApplicationsRequestOpts(
        requestParameters: ListCoachApplicationsRequest
    ): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        if (requestParameters['kind'] != null) {
            queryParameters['kind'] = requestParameters['kind']
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status']
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page']
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage']
        }

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/coach/applications`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * List coach and business applications (admin only)
     */
    async listCoachApplicationsRaw(
        requestParameters: ListCoachApplicationsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1CoachApplicationList>> {
        const requestOptions =
            await this.listCoachApplicationsRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1CoachApplicationListFromJSON(jsonValue)
        )
    }

    /**
     * List coach and business applications (admin only)
     */
    async listCoachApplications(
        requestParameters: ListCoachApplicationsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1CoachApplicationList> {
        const response = await this.listCoachApplicationsRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for listRequestMessages without sending the request
     */
    async listRequestMessagesRequestOpts(
        requestParameters: ListRequestMessagesRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listRequestMessages().'
            )
        }

        const queryParameters: any = {}

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit']
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset']
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order']
        }

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/{id}/messages`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * List messages for a request
     */
    async listRequestMessagesRaw(
        requestParameters: ListRequestMessagesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1MessageList>> {
        const requestOptions =
            await this.listRequestMessagesRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1MessageListFromJSON(jsonValue)
        )
    }

    /**
     * List messages for a request
     */
    async listRequestMessages(
        requestParameters: ListRequestMessagesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1MessageList> {
        const response = await this.listRequestMessagesRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for listRequests without sending the request
     */
    async listRequestsRequestOpts(
        requestParameters: ListRequestsRequest
    ): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        if (requestParameters['requesterId'] != null) {
            queryParameters['requesterId'] = requestParameters['requesterId']
        }

        if (requestParameters['coachId'] != null) {
            queryParameters['coachId'] = requestParameters['coachId']
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status']
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit']
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset']
        }

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * List programme requests (sent by user or received by coach)
     */
    async listRequestsRaw(
        requestParameters: ListRequestsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1ProgrammeRequestList>> {
        const requestOptions =
            await this.listRequestsRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1ProgrammeRequestListFromJSON(jsonValue)
        )
    }

    /**
     * List programme requests (sent by user or received by coach)
     */
    async listRequests(
        requestParameters: ListRequestsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1ProgrammeRequestList> {
        const response = await this.listRequestsRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for listenRequestEvents without sending the request
     */
    async listenRequestEventsRequestOpts(
        requestParameters: ListenRequestEventsRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listenRequestEvents().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/{id}/listen`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * SSE stream for real-time request status and message updates
     */
    async listenRequestEventsRaw(
        requestParameters: ListenRequestEventsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1RequestEvent>> {
        const requestOptions =
            await this.listenRequestEventsRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1RequestEventFromJSON(jsonValue)
        )
    }

    /**
     * SSE stream for real-time request status and message updates
     */
    async listenRequestEvents(
        requestParameters: ListenRequestEventsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1RequestEvent> {
        const response = await this.listenRequestEventsRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for saveCoachSettings without sending the request
     */
    async saveCoachSettingsRequestOpts(
        requestParameters: SaveCoachSettingsRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1CoachSettingsPayload'] == null) {
            throw new runtime.RequiredError(
                'v1CoachSettingsPayload',
                'Required parameter "v1CoachSettingsPayload" was null or undefined when calling saveCoachSettings().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/coach/settings`

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: V1CoachSettingsPayloadToJSON(
                requestParameters['v1CoachSettingsPayload']
            )
        }
    }

    /**
     * Update coach request settings
     */
    async saveCoachSettingsRaw(
        requestParameters: SaveCoachSettingsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<void>> {
        const requestOptions =
            await this.saveCoachSettingsRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.VoidApiResponse(response)
    }

    /**
     * Update coach request settings
     */
    async saveCoachSettings(
        requestParameters: SaveCoachSettingsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<void> {
        await this.saveCoachSettingsRaw(requestParameters, initOverrides)
    }

    /**
     * Creates request options for savePayoutWallet without sending the request
     */
    async savePayoutWalletRequestOpts(
        requestParameters: SavePayoutWalletRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1PayoutWallet'] == null) {
            throw new runtime.RequiredError(
                'v1PayoutWallet',
                'Required parameter "v1PayoutWallet" was null or undefined when calling savePayoutWallet().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/coach/payout-wallet`

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: V1PayoutWalletToJSON(requestParameters['v1PayoutWallet'])
        }
    }

    /**
     * Set the coach\'s payout wallet (empty clears it)
     */
    async savePayoutWalletRaw(
        requestParameters: SavePayoutWalletRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1PayoutWallet>> {
        const requestOptions =
            await this.savePayoutWalletRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1PayoutWalletFromJSON(jsonValue)
        )
    }

    /**
     * Set the coach\'s payout wallet (empty clears it)
     */
    async savePayoutWallet(
        requestParameters: SavePayoutWalletRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1PayoutWallet> {
        const response = await this.savePayoutWalletRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for sendRequestMessage without sending the request
     */
    async sendRequestMessageRequestOpts(
        requestParameters: SendRequestMessageRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sendRequestMessage().'
            )
        }

        if (requestParameters['v1SendMessagePayload'] == null) {
            throw new runtime.RequiredError(
                'v1SendMessagePayload',
                'Required parameter "v1SendMessagePayload" was null or undefined when calling sendRequestMessage().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/{id}/messages`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1SendMessagePayloadToJSON(
                requestParameters['v1SendMessagePayload']
            )
        }
    }

    /**
     * Send a message in the request conversation
     */
    async sendRequestMessageRaw(
        requestParameters: SendRequestMessageRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<void>> {
        const requestOptions =
            await this.sendRequestMessageRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.VoidApiResponse(response)
    }

    /**
     * Send a message in the request conversation
     */
    async sendRequestMessage(
        requestParameters: SendRequestMessageRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<void> {
        await this.sendRequestMessageRaw(requestParameters, initOverrides)
    }

    /**
     * Creates request options for submitCoachApplication without sending the request
     */
    async submitCoachApplicationRequestOpts(
        requestParameters: SubmitCoachApplicationRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1CoachApplicationPayload'] == null) {
            throw new runtime.RequiredError(
                'v1CoachApplicationPayload',
                'Required parameter "v1CoachApplicationPayload" was null or undefined when calling submitCoachApplication().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/coach/application`

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1CoachApplicationPayloadToJSON(
                requestParameters['v1CoachApplicationPayload']
            )
        }
    }

    /**
     * Submit a coach application
     */
    async submitCoachApplicationRaw(
        requestParameters: SubmitCoachApplicationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1CoachApplication>> {
        const requestOptions =
            await this.submitCoachApplicationRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1CoachApplicationFromJSON(jsonValue)
        )
    }

    /**
     * Submit a coach application
     */
    async submitCoachApplication(
        requestParameters: SubmitCoachApplicationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1CoachApplication> {
        const response = await this.submitCoachApplicationRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for updateRequestStatus without sending the request
     */
    async updateRequestStatusRequestOpts(
        requestParameters: UpdateRequestStatusRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRequestStatus().'
            )
        }

        if (requestParameters['v1StatusUpdatePayload'] == null) {
            throw new runtime.RequiredError(
                'v1StatusUpdatePayload',
                'Required parameter "v1StatusUpdatePayload" was null or undefined when calling updateRequestStatus().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/requests/{id}/status`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1StatusUpdatePayloadToJSON(
                requestParameters['v1StatusUpdatePayload']
            )
        }
    }

    /**
     * Update request status (accept/reject/deliver/complete/dispute)
     */
    async updateRequestStatusRaw(
        requestParameters: UpdateRequestStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1ProgrammeRequest>> {
        const requestOptions =
            await this.updateRequestStatusRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1ProgrammeRequestFromJSON(jsonValue)
        )
    }

    /**
     * Update request status (accept/reject/deliver/complete/dispute)
     */
    async updateRequestStatus(
        requestParameters: UpdateRequestStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1ProgrammeRequest> {
        const response = await this.updateRequestStatusRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }
}

/**
 * @export
 */
export const ListCoachApplicationsStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const
export type ListCoachApplicationsStatusEnum =
    (typeof ListCoachApplicationsStatusEnum)[keyof typeof ListCoachApplicationsStatusEnum]
/**
 * @export
 */
export const ListRequestMessagesOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const
export type ListRequestMessagesOrderEnum =
    (typeof ListRequestMessagesOrderEnum)[keyof typeof ListRequestMessagesOrderEnum]
